// extracted by mini-css-extract-plugin
module.exports = {"main":"NotificationWarningPill_main__vKw18","number":"NotificationWarningPill_number__TU_d6"};